import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function clientSyncContractType(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLIENT_SYNC_ISSUESET,
    (
      organisationId,
      clientId,
      issuesetMasterId,
      syncList,
      onSuccess,
      onError,
    ) =>
      requestor
        .put(
          `${basePath}/organisation/${organisationId}/client/${clientId}` +
            `/issuesetMasterId/${issuesetMasterId}/syncList/${syncList}`,
          {},
          {withCredentials: true},
        )
        .then(response => {
          onSuccess();
          return {
            clientId,
            issuesetMasterId,
            syncList,
            last_sync_date: response.data,
          };
        })
        .catch(err => {
          onError(err);
          return err.data;
        }),
  );
}
